'use client';

import { handleRequest } from "./common";
// import { websocketRequest } from "./requests";

export async function uploadFile(file: File, fileType: string) {
  const url = await getPresignedUrl(file.name, fileType)

  if (url) {
    console.log('Presigned URL:', url); // Log the presigned URL
    console.log('File details:', {
      name: file.name,
      type: file.type,
      size: file.size,
    }); // Log the file details

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read',
        },
        body: file,
      });

      console.log('Fetch response status:', response.status); // Log the response status
      console.log('Fetch response headers:', response.headers); // Log the response headers
      const responseBody = await response.text(); // Read the response body
      console.log('Fetch response body:', responseBody); // Log the response body

      if (!response.ok) {
        throw new Error('Failed to upload file');
      }

      console.log('File uploaded successfully');
      
      return file.name
    } catch (error) {
      console.error('Error uploading file:', error);
      return ""
    }
  } else {
    console.error('Failed to get presigned URL');
    return ""
  }
}


export async function getPresignedUrl(fileName: string, fileType: string) {
  const data = await handleRequest(`/chatapp/presigned_url/${fileType}`, 'POST', {key: fileName});
  return data.url;
}

